<template>
<v-row>
<v-dialog
  v-model="dialog"
  fullscreen
  max-width="800"
  scrollable
  transition="dialog-bottom-transition"
>
  <v-card
    v-if="controller"
    flat tile
    height="530"
  >
    <v-toolbar
    max-height="64"
    dark
    style="background-color: #044F67"
    >
      <template slot="default">
        <v-toolbar-title>{{ controller.name }} @ {{ controller.authid }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </v-toolbar>

    <v-flex>
      <v-data-table
      :headers="headers"
      :items="connections"
      :options.sync="options"
      :server-items-length="total"
      class="elevation-0 pt-5"
      item-key="connectionid"
      no-data-text="пусто"
      no-results-text="ничего не найдено"
      loading-text="идет загрузка"
      dense
      flat
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: [ 10, 20, 30],
        itemsPerPageText: 'Показывать:',
      }"
      >
        <template v-slot:item.cts="{ item }">
          {{ dateFormat(item.cts) }}
        </template>
        <template v-slot:item.closedat="{ item }">
          {{ item.closedat ? dateFormat(item.closedat) : null }}
        </template>
        <template v-slot:item.age="{ item }">
          <span :style="`color: ${item.age.milliseconds < 3600000 ? '#D50000' : ''}`"
          >{{ item.age.text }}</span>
        </template>
        <template v-slot:item.closemsg="{ item }">
          {{ item.closemsg }}
        </template>
      </v-data-table>
    </v-flex>
  </v-card>
</v-dialog>
</v-row>
</template>

<script>
import moment from 'moment'
import humanizeDuration from 'humanize-duration'

export default {
  name: 'DialogControllerConnections',
  props: ['value'],
  data: () => ({
    dialog: false,
    connections: [],
    controller: null,
    total: 0,
    headers: [
      { text: 'контроллер', value: 'controller', width: '150', sortable: false },
      { text: 'подключение', value: 'cts', width: '150', sortable: false  },
      { text: 'отключение', value: 'closedat', width: '150', sortable: false  },
      { text: 'время жизни', value: 'age', width: '200', sortable: false  },
      { text: 'сообщение', value: 'closemsg', sortable: false  },
    ],
    options: {
      page: 1,
      itemsPerPage: 20,
    }
  }),
  methods: {
    close () {
      this.dialog = false
    },
    async fetch () {
      try {
        await this.fetchControllerHistory()
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    async fetchControllerHistory () {
      const { meta, connections, total } = await this.$store.dispatch('sioRequest', {
        topic: 'controller-history',
        pl: {
          authid: this.controller.authid,
          order: 'desc',
          page: this.options.page,
          limit: this.options.itemsPerPage
        }
      })
      this.connections = connections.map(x => {
        const milliseconds = moment(x.closedat || undefined).diff(moment(x.cts), 'milliseconds')
        x.age = {
          milliseconds,
          text: humanizeDuration(
            milliseconds,
            { language: 'ru', largest: 2, round: true }
          )
        }
        return x
      })
      this.total = parseInt(total)
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
  },
  watch: {
    value (val) {
      this.controller = val
      if (val) {
        this.dialog = true
      }
    },
    options: {
      handler () {
        if (this.controller && this.dialog) this.fetch()
      },
      deep: true,
    },
    dialog (val) {
      if (!val) {
        this.controller = null
        this.connections = []
        this.options.page = 1
        this.$emit('input', null)
      }
    }
  },
}
</script>

<style lang="css">
</style>
